import React from 'react'
import './About.css'
import  { useEffect, useRef } from "react";
import lottie from "lottie-web";
import img1 from '../../../images/year-about.png'
import img2 from '../../../images/university-about.png'
import { faCode, faHandPeace, faObjectGroup, faShieldHeart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function About() {
    const container = useRef(null);

    useEffect(() => {
        lottie.loadAnimation({
          container: container.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: require("../../../animation/about.json")
        });
    
        return () => {
          lottie.destroy();
        };
      }, []);
  return (
    
    <>
        <div className="about" id='about'>
            
            <div className="container">
                <div className="heading">
                    <h5>WHO AM I</h5>
                    <h2 data-aos="zoom-in" data-aos-duration="2500">About</h2>
                    <span>A Story About Me</span>
                </div>
                <div className="text-about" data-aos="fade-up" data-aos-duration="2500">
                    <p>A JOURNEY OF CURIOSITY <br/> AND EXPLORATIONS</p>
                </div>
                <div className="information" data-aos="zoom-out-up" data-aos-duration="1000">
                    <div className="who-iam" >
                        <p>I'm Eslam Elhadidy 22 years old, I hold a Bachelor of Computers and Information Science  (Information Technology) Department at Mansoura University, I work as a front-end developer and I have enough experience to work on more than one project and under pressure because of my ability to organize my time and divide the required tasks in a way that facilitates the completion of work in the best way.</p>
                        <p>I have serious passion for UI effects, animations and creating intuitive, dynamic user experiences.
                        Each project is a new opportunity to learn new concepts across multiple domains.</p>
                    </div>
                    <div className="square-info">
                        <p><img src={img1} alt="" /> 22 <br/> Years Old</p>
                        <p><img src={img2} alt="" />Mansoura university<br/>
                            Faculty OF CIS<br/>
                            IT departement</p>
                    </div>
                </div>

                <div className="offers">
                    <p>I Offer What ? ...</p>
                    <div className="offers-container" data-aos="fade-up"
     data-aos-duration="1000" data-aos-easing="linear">
                        <div className="box" >
                            <FontAwesomeIcon icon={faObjectGroup} />
                            <div className='number'>01</div>
                            <div className='title'>Web Design</div>
                            <div className='subj'>I have the ability and work to design an integrated website that is responsive to all screens using the required technologies</div>
                        </div>
                        <div className="box" >
                            <FontAwesomeIcon icon={faCode} />
                            <div className='number'>02</div>
                            <div className='title'>Convert UI To Website</div>
                            <div className='subj'>I have the ability and work to convert any UI to website and responsive to all screens with the required technologiess</div>
                        </div>
                    </div>
                    <div className="offers-container-2" data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="1000">
                        <div className="box">
                            <FontAwesomeIcon icon={faHandPeace} />
                            <div className='number'>03</div>
                            <div className='title'>Creative Implementation</div>
                            <div className='subj'>It is all about putting creativity to work.
                            Ideas are useless unless used. The proof of their value is their implementation. Until then they are in limbo.</div>
                        </div>
                        <div className="box">
                            <FontAwesomeIcon icon={faShieldHeart} />
                            <div className='number'>04</div>
                            <div className='title'>Modern And Clean Code</div>
                            <div className='subj'>I have the ability and work to convert any UI to website and responsive to all screens with the required technologiess</div>
                        </div>
                    </div>
                </div>
                <div className="journey" data-aos="fade-up"
                data-aos-anchor-placement="center-center">
                    <div className='heading-journey'>My Coding Journey</div>
                    <div className="container-journey">
                        <div className='about-journey' data-aos="fade-right" data-aos-duration="3000">I started learning programming one years ago and I had a passion in the field of web development, but I needed to be established in this field, so I read about c++, oop , python , c# , and data structure, then I moved to developing sites, so I learned a lot of skills Which makes me unique in the design of the front-end sites. I look forward to learning more skills in the future.</div>
                        <div className='img' ref={container}></div>
                    </div>
                    <div className='fact'>I'm still Learnin' casue i have a long way to go
                    </div>
                </div>
            </div>
        </div>
    
    </>
  )
}

export default About